module.exports = __webpack_public_path__ + "static/img/subscribe.bcd9bf66.jpg";